export class BdPostalCodeStore {
  constructor(private readonly _baseUrl: string) {}

  public index(): string {
    return `${this._baseUrl}/postal-codes/`;
  }

  public findOne(postalCode: string): string {
    return `${this.index()}${postalCode}`;
  }

  public postalCodes(): string {
    return `${this._baseUrl}/postal-codes/center-points`;
  }
}
